export const Table = ({ children }) => {
  return (
    <table className="w-full text-base">{children}</table>
  );
};
